import { useUserType } from './useUserType';

export const useIsAdmin = (): boolean | undefined => {
  const { userType } = useUserType();
  return userType ? userType === 'Admin' : undefined;
};
